import * as Dialog from '@radix-ui/react-dialog';
import { Button } from '../../../../components/ui/button';

interface SaveConfirmationProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  section: string;
}

export function SaveConfirmationModal({
  open,
  onOpenChange,
  onConfirm,
  section,
}: SaveConfirmationProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50 z-[9999]" />
        <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-background rounded-lg shadow-lg p-6 w-full max-w-md z-[10000] text-text-primary">
          <Dialog.Title className="text-2xl font-bold text-primary mb-2">
            Save regenerated {section.toLowerCase()}?
          </Dialog.Title>
          <Dialog.Description className=" mb-6">
            Do you want to continue with the new {section.toLowerCase()}? Once
            it is saved you can&apos;t go back to the original one.
          </Dialog.Description>
          <div className="flex justify-end gap-3">
            <Button
              onClick={() => onOpenChange(false)}
              variant="customSecondary"
              className="bg-secondary text-primary "
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                onConfirm();
                onOpenChange(false);
              }}
              variant="customSecondary"
              className="bg-secondary "
            >
              Save
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
